"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationTimeline = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const animation_timeline_1 = require("./animation-timeline");
const AnimationTimeline = ({ metadata, pages, size, options, onComplete, }) => {
    const animationRef = (0, react_1.useRef)(null);
    const [animation, setAnimation] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (animationRef.current && animation === null) {
            const timeline = (0, animation_timeline_1.createProjectTimeline)(animationRef.current, metadata, pages, options);
            onComplete && timeline.eventCallback('onComplete', () => onComplete());
            setAnimation(timeline);
        }
        return () => {
            if (animation) {
                animation.kill();
            }
        };
    }, [animationRef.current]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { style: {
                width: size.width,
                height: size.height,
            }, ref: animationRef }) }));
};
exports.AnimationTimeline = AnimationTimeline;
//# sourceMappingURL=AnimationTimeline.js.map